<div class="main-screen-container">
    <div class="top-row">
        <h3 class="w-100">Statusy maszyn</h3>
        <div class="d-flex flex-row gap-3">
            <mat-form-field appearance="outline">
                <mat-label style="color: gray;">Szukaj...</mat-label>
                <input matInput [formControl]="filter" (blur)="saveFilter()">
            </mat-form-field>
        </div>
        <div class="d-flex flex-fill justify-content-end gap-3">
            <button mat-flat-button class="big-button" (click)="onOpenStatusTypeForm()">
                <mat-icon class="big-icon">add</mat-icon>
                Dodaj status
            </button>
            <button mat-flat-button class="big-button" color="accent" (click)="fetchStatusTypes()">
                <mat-icon class="big-icon m-0">refresh</mat-icon>
            </button>
            
        </div>
        <div class="d-flex flex-row align-items-center justify-content-end p-2 gap-3 w-100">
            <button mat-flat-button (click)="clearFilter()">Wyczyść filter</button>
        </div>
        
    </div>
     
    
    <table mat-table matSort [dataSource]="dataSource" class="common-table">
         <!-- name_pl Column -->
        <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>STATUS</th>
        <td mat-cell *matCellDef="let element"> {{element.id}} </td>
        </ng-container>
        
        <!-- name Column -->
        <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>NAZWA</th>
        <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>

        <!-- name_pl Column -->
        <ng-container matColumnDef="name_pl">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>NAZWA</th>
        <td mat-cell *matCellDef="let element"> {{element.pl_name}} </td>
        </ng-container>

        <!-- description Column -->
        <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>OPIS</th>
        <td mat-cell *matCellDef="let element"> {{element.description}} </td>
        </ng-container>

        <!-- description Column -->
        <ng-container matColumnDef="instruction">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>INSTRUKCJA</th>
        <td mat-cell *matCellDef="let element"> {{'"Do zrobienia"'}} </td>
        </ng-container>
        
        <!-- type Column -->
        <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>TYP STATUSU</th>
        <td mat-cell *matCellDef="let element"> 
            <span *ngIf="element.alert" color="blue">Informacja</span>
            <span *ngIf="!element.alert" color="red">Awaria</span> 
        </td>
        </ng-container>

        <!-- action Column -->
        <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td mat-cell *matCellDef="let element"> 
            <mat-icon [matMenuTriggerFor]="menu" class="action-button">more_vert</mat-icon>

            <!-- Action Menu -->
            <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="onOpenStatusTypeForm(element.id)"><mat-icon>edit</mat-icon>Edytuj</button>
                <button mat-menu-item (click)="onDeleteStatusType(element.id)"><mat-icon>delete</mat-icon>Usuń</button>
            </mat-menu>
        </td>
        </ng-container>
        
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[25, 10, 50]"
        showFirstLastButtons
        aria-label="Wybierz stronę">
    </mat-paginator>
    <div class="w-100 d-flex justify-content-center" *ngIf="isLoading || errorMessage"><mat-spinner *ngIf="isLoading"></mat-spinner> <h4 *ngIf="errorMessage">{{errorMessage}}</h4></div>
</div>

